import * as ko from 'knockout';

import { BaseForm } from 'main/screens/base_form';
import { License } from '../models/license';
import { LicenseData, licenseApi } from '../api/simple_api';
import { Deferred } from 'main/utils/deferred';
import { createWithComponent } from 'main/utils/ko_utils';

let template = require('raw-loader!../../templates/license_edit.html').default;

class LicenseEditScreen extends BaseForm<LicenseData> {
    entity = ko.observable<License>(null);

    constructor(params: { id: string, result?: Deferred<LicenseData> }, componentInfo: KnockoutComponentTypes.ComponentInfo) {
        super(params);

        let request = params.id ? licenseApi.retrieve(params.id) : undefined;
        let promise = Promise.all([request]).then(([data]) => {
            this.entity(new License(data));
        });
        this.loadedAfter(promise).then(() => this.focusFirst(componentInfo.element));
    }

    save = () => {
        if (! this.entity()) {
            return;
        }

        if (this.validateLocal(this.entity)) {
            let data = this.entity().toData();
            this.executeSaveRequest(licenseApi.save(data)).then((validation) => {
                this.onRemoteValidation(data, this.entity(), validation);
            });
        }
    }
}

export let licenseEdit = { name: 'license-edit', viewModel: createWithComponent(LicenseEditScreen), template: template };

ko.components.register(licenseEdit.name, licenseEdit);
